import { RootState } from '../../../config';
import { ViewMode } from '../../../../hooks/useViewMode';
import { APIFilterParams } from './initialState';
import { mapFilterStateToAPIParams } from './reducer';
import getTargets from '../../../../components/Filter/helpers/getTargets';

export const selectFilter = (state: RootState) => state.ui.filter;

export const selectIsFilterPanelOpen = (state: RootState) =>
  state.ui.filter.isPanelOpen;

export const selectFilterTarget = (state: RootState) => state.ui.filter.target;

export const selectFilterTargetType = (state: RootState) =>
  state.ui.filter.targetType;

export const selectFilterFor = (viewMode: ViewMode) => (state: RootState) =>
  // @ts-ignore
  state.ui.filter[viewMode];

/**
 * Derived from the *current* view mode's filter slice. Computing on read
 * (rather than caching a shared field in the reducer) prevents one table's
 * filters from leaking into another's request when the user navigates between
 * tables without modifying filters.
 */
export const selectAPIFilterParams = (
  state: RootState
): APIFilterParams | null => {
  const viewMode = state.ui.common.viewMode;
  // @ts-ignore — filter state is keyed by ViewMode string
  const filterState = state.ui.filter[viewMode];
  if (!filterState) return null;
  return mapFilterStateToAPIParams(filterState, getTargets(viewMode));
};

export const selectFilters = (state: RootState) => state.ui.filter;
